// Domain types for the Admin Sales Executives MSPA.

// A row in the sales executives list table.
export interface SalesExecutive {
  id: string;
  name: string;
  phone?: string;
  email?: string;
  title?: string;
  active?: boolean;
}

// Controlled values for the sales executive create/edit form.
export interface SalesExecutiveFormValues {
  name: string;
  title: string;
  phone: string;
  email: string;
}

export const emptySalesExecutiveForm: SalesExecutiveFormValues = {
  name: "",
  title: "",
  phone: "",
  email: "",
};
